export const getShortDataTable = (data) => {
    if (!data) return

    return data.map((item, i) => {
        const {
            name = "",
            columns = [],
            rows = []
        } = item;

        if (i === 0) {
            return ['', ...columns.map(({value}) => value)]
        } else {
            const tmpArr = rows?.[0]?.rowValues || []
            return [name, ...tmpArr.map(({value}) => value)]
        }
    })
}